/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";

export const StreamBankRemoveItemRow = (props) => {
    const {
        children,
    } = props;

    return (
        <div className="pop-row sb-mutable-list-remove-row">
            {children}
        </div>
    );
};
